import React from 'react';
import { observer } from 'mobx-react';
import { FaqCategoryShowWrapper } from '@seedlang/hoc';
import styled from '@emotion/styled';
import FaqHeader, { FaqContentWrapper } from 'components/faq_header';
import FaqRow, { FaqRowGrid } from 'components/faq_row';
import Spinner from 'components/spinner';
import Fa from 'components/fa';
import { AppUI } from '@seedlang/state';
import withRouteParams from 'utils/with_route_params';
import Text from 'components/text';
import Button from 'components/button/button';

const Message = styled.div`
  background: white;
  border-radius: 5px;
  padding: 30px;
  text-align: center;
`;

@observer
class FaqCategoryShow extends React.Component {

  render() {
    const faqItems = (this.props.faqCategory?.faqItems || []).filter(item => AppUI.user.admin || item.published);

    return (
      <FaqContentWrapper>
        <FaqHeader
          currentRoute='faq_categories.show'
          faqCategoryName={this.props.faqCategory.name}
          margin='0 0 10px 0'
        />
        {
          this.props.isLoading &&
          <Spinner />
        }
        {
          !this.props.isLoading && this.props.loadFailed &&
          <Message>
            <Text margin='0 0 15px 0'>
              Sorry, we couldn&apos;t load the articles in this topic.
            </Text>
            <Button onClick={this.props.retryLoad}>
              Try Again
            </Button>
          </Message>
        }
        {
          !this.props.isLoading && !this.props.loadFailed && faqItems.length === 0 &&
          <Message>
            <Text>There aren&apos;t any articles in this topic yet.</Text>
          </Message>
        }
        {
          !this.props.isLoading && !this.props.loadFailed && faqItems.length > 0 &&
          <FaqRowGrid>
            {
              faqItems.map(item => (
                <FaqRow
                  key={item.id}
                  to={{ name: 'faq_items.show', params: { faqCategoryId: this.props.faqCategory.id, faqItemId: item.id } }}
                  icon={<Fa i={item.icon || 'files-o'} />}
                  title={item.titleWithPublished}
                  description={item.description}
                />
              ))
            }
          </FaqRowGrid>
        }
      </FaqContentWrapper>
    );
  }
}

export default withRouteParams(FaqCategoryShowWrapper(FaqCategoryShow));
